module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"day-filter:title":"Выберите дату","day-filter:accept":"Применить","day-filter:reset":"Сброс"}}')
  delete Component.options._Ctor
}
